import { useContext } from 'react'

import { Breakpoints } from '@hhgtech/hhg-components'
import { Button, Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps, Stack } from '@mantine/core'

import useStyles from './index.styles'
import { CtaBannerContext } from '../../context'
import { MultipleBanner } from '../../index.types'
type Props = {
  data: MultipleBanner['listing'][number]['banners'][number]
  layout: MultipleBanner['layout']
  infoLayout: 'horizon' | 'vertical'
  ratio?: number
  radius?: number
} & BoxProps

export const Item = ({
  data,
  layout,
  styles,
  classNames,
  infoLayout = 'horizon',
  ratio = 312 / 430,
  radius = 24,
  ...rest
}: Props) => {
  const { data: bannerData } = useContext(CtaBannerContext)
  const { fixSizeBanner } = (bannerData || {}) as MultipleBanner
  const {
    desktop,
    mobile,
    title,
    titleColor,
    description,
    descriptionColor,
    buttons,
  } = data
  const { classes } = useStyles(
    { layout, infoLayout, ratio, fixSizeBanner, radius },
    {
      name: 'CtaBannerSection__MultipleImage__Item',
      styles,
      classNames,
    },
  )
  const primaryButton = buttons?.primary
  const buttonLink = primaryButton?.url
  const buttonTitle = primaryButton?.title
  return (
    <Box
      {...rest}
      {...(buttonLink && {
        component: 'a' as any,
        href: buttonLink,
        target: primaryButton?.openNewTab ? '_blank' : '_self',
      })}
      className={classes.root}
      data-ratio={ratio}
    >
      <picture className={classes.picture}>
        <source
          media={`(min-width: ${Breakpoints.BREAK_POINT_TABLET}px)`}
          srcSet={desktop}
        />
        <img
          loading="lazy"
          src={mobile}
          alt="CTA Banner"
          width="100%"
          height="auto"
        />
      </picture>
      <Stack className={classes.info}>
        {layout === 'image_on_top_button_below' && (
          <>
            {(title || description) && (
              <Stack className={classes.header}>
                {title && (
                  <Text size="h5" color={titleColor} variant="primary">
                    {title}
                  </Text>
                )}
                {description && (
                  <Text
                    size="p2"
                    as="div"
                    variant="tertiary"
                    color={descriptionColor}
                    dangerouslySetInnerHTML={{
                      __html: description,
                    }}
                  />
                )}
              </Stack>
            )}
          </>
        )}
        {buttonTitle && (
          <Box className={classes.actions}>
            <Button
              className={classes.btn}
              variant="primary"
              size="lg"
              sx={(theme) => ({
                backgroundColor: `${primaryButton.backgroundColor} !important`,
                '&:hover': {
                  backgroundColor: `${theme.fn.darken(
                    primaryButton.backgroundColor,
                    0.05,
                  )} !important`,
                },
              })}
            >
              {buttonTitle}
            </Button>
          </Box>
        )}
      </Stack>
    </Box>
  )
}
